import React from "react";
import { FaInstagram } from "react-icons/fa";
import { FiGithub } from "react-icons/fi";
import { CiLinkedin } from "react-icons/ci";
import Home1 from "./Home1";
import { Link } from "react-router-dom";

function Home() {
  const text =
    "Committed to continuous learning and innovation, I strive to deliver high-quality solutions that make a meaningful impact.";
  return (
    <>
      {/* My Initial */}
      <div className="absolute left-0 lg:relative lg:left-0 flex  gap-6 flex-col pt-[70px]">
        <Link target="_blank" to={"https://www.instagram.com/kohlishreyash/"}>
          <FaInstagram fontSize={"1.5rem"} />
        </Link>

        <Link target="_blank" to={"https://github.com/shreyash9806/Full-Stack-Web-Development"}>
          <FiGithub fontSize={"1.5rem"} />
        </Link>

        <Link target="_blank" to={"https://www.linkedin.com/in/shreyash-kumar-78026821a/"}>
          <CiLinkedin fontSize={"1.5rem"} />
        </Link>
      </div>

      {/* Name, Introduction and Profile Picture*/}
      <div
        className="flex flex-col-reverse
      lg:flex lg:flex-row lg:justify-end lg:gap-16 lg:pr-[30px]
      "
      >
        <div className="hidden lg:w-[55%] lg:flex lg:flex-col lg:items-start">
          <Home1 Extra={text} />
        </div>
        {/* Profile Picture */}
        <div className="profile-image w-[280px] h-[300px]"></div>
      </div>
    </>
  );
}

export default Home;
